import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { of } from 'rxjs';

import { AddressBodyPayload, AddressNew, Address } from '@erm/cluster';

import { convertKeysToSnakeCase } from '@shared/utils';
import { ORGANIZATION_URL } from '@data-access/shared';

import {
  CreateOrgPayload,
  OrganizationDetail,
  OrgExists,
  UpdateOrganizationPayload,
} from '../types';

@Injectable()
export class OrganizationService {
  private readonly _http = inject(HttpClient);

  loadOrganization(organizationId: string) {
    return this._http.get<OrganizationDetail>(
      `${ORGANIZATION_URL}${organizationId}/`,
    );
  }

  updateOrganization(organizationId: string, data: UpdateOrganizationPayload) {
    return this._http.put<OrganizationDetail>(
      `${ORGANIZATION_URL}${organizationId}/`,
      convertKeysToSnakeCase(data),
    );
  }

  deactivateOrganization(organizationId: string) {
    return this._http.put<OrganizationDetail>(
      `${ORGANIZATION_URL}${organizationId}/deactivate/`,
      {},
    );
  }

  getActiveOrganizationEntities(organizationId: string) {
    return this._http.get<{ num_studies: number; num_sites: number }>(
      `${ORGANIZATION_URL}${organizationId}/active-study-site-counts/`,
    );
  }

  addAddress(entityId: string, data: AddressBodyPayload) {
    return this._http.post<AddressNew>(
      `${ORGANIZATION_URL}${entityId}/address/`,
      convertKeysToSnakeCase(data),
    );
  }

  updateAddress(entityId: string, data: AddressBodyPayload) {
    return this._http.put<Address>(
      `${ORGANIZATION_URL}${entityId}/address/${data.id}/`,
      convertKeysToSnakeCase(data),
    );
  }

  removeAddress(entityId: string, addressId: string) {
    return this._http.delete(
      `${ORGANIZATION_URL}${entityId}/address/${addressId}/`,
    );
  }

  /**
   * @TODO IMPLEMENT CHECK IF CAN REMOVE ADDRESS
   * */
  checkIfCanRemoveAddress(_: string, __: string) {
    return of(false);
  }

  checkExists(countryId: string) {
    const _params = new HttpParams().set('name', countryId);
    return this._http.get<OrgExists>(`${ORGANIZATION_URL}exists/`, {
      params: _params,
    });
  }

  createOrg(orgData: CreateOrgPayload) {
    return this._http.post<OrganizationDetail>(
      `${ORGANIZATION_URL}`,
      convertKeysToSnakeCase(orgData),
    );
  }
}
